import _asyncToGenerator from'@babel/runtime/helpers/asyncToGenerator';import _regeneratorRuntime from'@babel/runtime/regenerator';import React,{useCallback}from'react';import {useHistory}from'react-router-dom';import PropTypes from'prop-types';import dayjs from'dayjs';import TimeoutComponent from'../TimeoutComponent/TimeoutComponent.js';import usePathBuilder from'../../hooks/usePathBuilder.js';function SessionTimeoutHandler(props) {
  var maxIdleExpirationTime = props.maxIdleExpirationTime,
    maxSessionExpirationTime = props.maxSessionExpirationTime,
    sessionInfoFetched = props.sessionInfoFetched,
    isLoggingOut = props.isLoggingOut,
    handleLogout = props.handleLogout,
    refreshSession = props.refreshSession,
    getSessionInfo = props.getSessionInfo;
  var history = useHistory();
  var pathBuilder = usePathBuilder();
  var handleTimeout = useCallback( /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(timeoutReason) {
      var path;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              if (!isLoggingOut) {
                _context.next = 2;
                break;
              }
              return _context.abrupt("return");
            case 2:
              _context.prev = 2;
              _context.next = 5;
              return handleLogout();
            case 5:
              _context.next = 9;
              break;
            case 7:
              _context.prev = 7;
              _context.t0 = _context["catch"](2);
            case 9:
              path = pathBuilder('/signin', true, {
                searchParams: {
                  sign_out: timeoutReason,
                  goto: ''
                }
              });
              history.push(path);
            case 11:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[2, 7]]);
    }));
    return function (_x) {
      return _ref.apply(this, arguments);
    };
  }(), [handleLogout, history, pathBuilder, isLoggingOut]);
  var extendSession = useCallback( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2() {
    return _regeneratorRuntime.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            _context2.prev = 0;
            _context2.next = 3;
            return refreshSession();
          case 3:
            _context2.next = 5;
            return getSessionInfo();
          case 5:
            _context2.next = 9;
            break;
          case 7:
            _context2.prev = 7;
            _context2.t0 = _context2["catch"](0);
          case 9:
          case "end":
            return _context2.stop();
        }
      }
    }, _callee2, null, [[0, 7]]);
  })), [refreshSession, getSessionInfo]);
  return /*#__PURE__*/React.createElement(TimeoutComponent, {
    maxIdleExpirationTime: maxIdleExpirationTime,
    maxSessionExpirationTime: maxSessionExpirationTime,
    sessionInfoFetched: sessionInfoFetched,
    onExtendSession: extendSession,
    onTimeout: handleTimeout
  });
}
process.env.NODE_ENV !== "production" ? SessionTimeoutHandler.propTypes = {
  maxIdleExpirationTime: PropTypes.instanceOf(dayjs),
  maxSessionExpirationTime: PropTypes.instanceOf(dayjs),
  sessionInfoFetched: PropTypes.bool,
  isLoggingOut: PropTypes.bool,
  handleLogout: PropTypes.func,
  refreshSession: PropTypes.func,
  getSessionInfo: PropTypes.func
} : void 0;
SessionTimeoutHandler.defaultProps = {
  maxIdleExpirationTime: undefined,
  maxSessionExpirationTime: undefined,
  sessionInfoFetched: undefined,
  isLoggingOut: undefined,
  handleLogout: undefined,
  refreshSession: undefined,
  getSessionInfo: undefined
};export{SessionTimeoutHandler as default};